var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"400px"}},[_c('l-map',{ref:"map",attrs:{"zoom":_vm.zoom,"options":_vm.options}},[_c('l-tile-layer',{attrs:{"url":_vm.url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }